<template>
  <div>
    <!-- File input and button to select a CSV file -->
    <input type="file" class="hidden" ref="fileInput" accept=".csv" @change="parseFile"/>
    <span class="main-button blue-button" @click="openFilePicker">CSV ile Kamera Ekle</span>
    <!-- Display the JSON objects here -->
  </div>
</template>

<script>
import * as Papa from 'papaparse'

export default {
  name: 'CSVParser',
  props: {
    updated: {
      type: Function
    }
  },
  data () {
    return {
      jsonObjects: []
    }
  },
  methods: {

    addKameraCSV (payload) {
      this.$store.dispatch('addKameraCSV', payload)
        .then((response) => {
          console.log('csv response', response)
          this.$vs.loading.close()
          this.updated(response)
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
        })
    },
    parseFile () {
      // Indexes of the fields in the CSV file
      const fieldIndexes = {
        bolgeAdi: 0,
        isletmeAdi: 1,
        seflikAdi: 2,
        kuleAdi: 3,
        enlem: 4,
        boylam: 5,
        rakim: 6,
        camType: 7,
        kuzeySabiti: 8,
        maxPan: 9,
        maxTilt: 10,
        tiltValue: 11,
        IP: 12,
        Port: 13,
        username: 14,
        password: 15,
        csvFilename: 16,
        tespitVar: 17,
        koordinatHesapla: 18,
        alarmNode: 19,
        camera_id: 20
      }

      // Get the selected file
      const file = this.$refs.fileInput.files[0]

      // Read in the CSV file
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          // Convert each row to a JSON object
          for (const row of results.data) {
            const jsonObj = {}
            for (const field of Object.keys(fieldIndexes)) {
              jsonObj[field] = row[field]
            }
            this.jsonObjects.push(jsonObj)
          }

          console.log('parsed json', this.jsonObjects)
          const payload = {
            list: this.jsonObjects
          }
          this.addKameraCSV(payload)
        }
      })
    },
    openFilePicker () {
      // Open the file picker dialog
      this.$refs.fileInput.click()
    }
  }
}
</script>
